module.exports = __webpack_public_path__ + "static/media/backWave22.2ec6812c.svg";